export enum TestType {
  echoGet = 'echoGet',
  echoPost = 'echoPost',
  successfulPayment = 'successfulPayment',
  canceledPayment = 'canceledPayment',
  expiredPayment = 'expiredPayment',
  reversedPayment = 'reversedPayment',
}
